"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MemberRole;
(function (MemberRole) {
    MemberRole["OWNER"] = "OWNER";
    MemberRole["SUPERVISOR"] = "SUPERVISOR";
    MemberRole["EMPLOYEE"] = "EMPLOYEE";
    MemberRole["EXTERNAL"] = "EXTERNAL";
    MemberRole["EXTERNALSUPERVISOR"] = "EXTERNAL_SUPERVISOR";
})(MemberRole = exports.MemberRole || (exports.MemberRole = {}));
//# sourceMappingURL=MemberRole.js.map